import { IS_HEADLESS_CHECKOUT_ATTRIBUTE_KEY, NOVEL_CUSTOMER_EVENT_CART_ATTRIBUTE_KEY, SESSION_SIGNATURE_CART_ATTRIBUTE_KEY, } from "@novel/shared/utils/shopIntegrationConstants";
const isJsonRegex = /^{\W*"/;
export function parseCartAttributes(cartAttributes) {
    if (!cartAttributes) {
        return {};
    }
    return Object.keys(cartAttributes).reduce((accum, key) => {
        const rawValue = cartAttributes[key];
        if ((rawValue === null || rawValue === void 0 ? void 0 : rawValue.trim) && isJsonRegex.test(rawValue.trim())) {
            accum[key] = JSON.parse(cartAttributes[key].replaceAll("=>nil", ":null").replaceAll("=>", ":"));
        }
        else {
            accum[key] = rawValue;
        }
        return accum;
    }, {});
}
export function parseCartAttributesArray(cartAttributesArray) {
    if (!cartAttributesArray) {
        return {};
    }
    // headless response has "key", webhook payload has "name"
    return parseCartAttributes(cartAttributesArray.reduce((accum, { key, name, value }) => {
        accum[key || name] = value;
        return accum;
    }, {}));
}
export function cartAttributesObjectToArray(cartAttributes) {
    if (!cartAttributes) {
        return [];
    }
    return Object.keys(cartAttributes).reduce((accum, key) => {
        const value = cartAttributes[key];
        if (value !== null && value !== undefined) {
            accum.push({
                key,
                value: typeof value === "object" ? JSON.stringify(value) : value,
            });
        }
        return accum;
    }, []);
}
export function parseSignatureFromOrder(order) {
    const parsedObj = parseCartAttributesArray(order.note_attributes);
    const isHeadless = parsedObj[IS_HEADLESS_CHECKOUT_ATTRIBUTE_KEY] === "true";
    return Object.assign({ sessionSignature: parsedObj[SESSION_SIGNATURE_CART_ATTRIBUTE_KEY] || "" }, (isHeadless
        ? {
        // `${order.checkout_id}`
        }
        : {
            signatureTargetIdentifier: order.cart_token,
        }));
}
export function parseCustomerPassEventFromOrder(order) {
    const parsedObj = parseCartAttributesArray(order.note_attributes);
    const customerEvent = parsedObj[NOVEL_CUSTOMER_EVENT_CART_ATTRIBUTE_KEY];
    return customerEvent || undefined;
}
